<template>
    <div>
        <v-card elevation="0" style="color: black;">
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="1">
                        <v-img src="../../../assets/background/Kings_international_3308.jpg" width="100%" height="120px" contain></v-img>
                    </v-col>
                    <v-col cols="12" md="10" class="d-flex align-center">
                        <span>
                            <span class="text-h4">Application for Part-Time Faculty Appointments - CUPE 5265</span><br />
                            <b>
                                King's University College is committed to recognizing the dignity and independence of all and seeks to ensure that persons with disabilities have genuine, open and unhindered access to the College's employment opportunities.
                                If you require an accommodation during the recruitment process, please contact Human Resources at <a href="mailto:HR@kings.uwo.ca">HR@kings.uwo.ca</a> or 519-433-3491 for assistance.
                            </b>
                        </span>
                    </v-col>
                </v-row>
                <v-card elevation="0" color="#f7f7f6">
                    <v-card-text>
                        <b>Have you held a CUPE position at King's in the past 36 months?</b>&nbsp;&nbsp;<span class="text-h6"><b>{{ item.cupeposition }}</b></span>
                        <br />
                        <b>Are you legally eligible to work in Canada?</b>&nbsp;&nbsp;<span class="text-h6"><b>{{ item.legaltowork }}</b></span>
                    </v-card-text>
                </v-card><br />
                <v-card elevation="0" color="#f7f7f6">
                    <v-card-title>Course Application&#40;s&#41;</v-card-title>
                    <v-card-text v-for="p in item.postings" :key="p.id">
                        <v-simple-table style="width: 100%; border-collapse: collapse;" dense>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th colspan="11">{{ p.title }} - {{ p.type }} Posting</th>
                                    </tr>
                                    <tr>
                                        <th rowspan="2">Term</th>
                                        <th rowspan="2">Section</th>
                                        <th rowspan="2">Class#</th>
                                        <th rowspan="2">Course</th>
                                        <th rowspan="2">Subject</th>
                                        <th rowspan="2">Name</th>
                                        <th rowspan="2">Component</th>
                                        <th colspan="5" style="text-align: center;">Days</th>
                                        <th rowspan="2">Instruction Period</th>
                                        <th rowspan="2">Time</th>
                                    </tr>
                                    <tr>
                                        <th>Mon</th>
                                        <th>Tue</th>
                                        <th>Wed</th>
                                        <th>Thu</th>
                                        <th>Fri</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="course in p.courses" :key="course.classnbr">
                                        <td>{{ resolveTerm(course.strm, course.sessioncode) }}</td>
                                        <td>{{ course.classsection }}</td>
                                        <td>{{ course.classnbr }}</td>
                                        <td>{{ course.catalognbr }}</td>
                                        <td>{{ course['subject-resolved'] }}</td>
                                        <td>{{ course.descr }}</td>
                                        <td>{{ course.ssrcomponent }}</td>
                                        <td><v-checkbox v-model="course.mon" disabled true-value="Mon"></v-checkbox></td>
                                        <td><v-checkbox v-model="course.tues" disabled true-value="Tue"></v-checkbox></td>
                                        <td><v-checkbox v-model="course.wed" disabled true-value="Wed"></v-checkbox></td>
                                        <td><v-checkbox v-model="course.thurs" disabled true-value="Thu"></v-checkbox></td>
                                        <td><v-checkbox v-model="course.fri" disabled true-value="Fri"></v-checkbox></td>
                                        <td>{{ course.instructionstart }} ~ {{ course.instructionend }}</td>
                                        <td>{{ course.starttime }} ~ {{ course.endtime }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                        <v-divider></v-divider>
                    </v-card-text>
                </v-card><br />
                <v-card elevation="0" color="#f7f7f6">
                    <v-card-text>
                        <v-expansion-panels v-model="panel" multiple>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    General Information
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-card elevation="0">
                                        <v-card-text>
                                            <v-row>
                                                <v-col cols="4">
                                                    <v-text-field label="First Name" outlined v-model="item.generalinfo.firstname" readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field label="Last Name" outlined v-model="item.generalinfo.lastname" readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field label="Preferred Name" outlined v-model="item.generalinfo.preferredname" readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-text-field label="Street Address" outlined v-model="item.generalinfo.address.street" readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field label="City" outlined v-model="item.generalinfo.address.city" readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field label="Province" outlined v-model="item.generalinfo.address.province" readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-text-field label="Postal Code" outlined v-model="item.generalinfo.address.postalcode" readonly></v-text-field>    
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-text-field label="Home Phone" outlined v-model="item.generalinfo.phone.home" readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-text-field label="Cell Phone" outlined v-model="item.generalinfo.phone.cell" readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-text-field readonly label="Email Address" outlined v-model="item.generalinfo.email"></v-text-field>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-text-field label="Western Email Address (optional)" outlined v-model="item.generalinfo.westernemail" readonly></v-text-field>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-radio-group v-model="item.generalinfo.preferredemail" mandatory row label="Preferred Email Adress" readonly>
                                                        <v-radio
                                                            label="Email Address"
                                                            value="email"
                                                        ></v-radio>
                                                        <v-radio
                                                            label="Western Email Address"
                                                            value="western"
                                                        ></v-radio>
                                                    </v-radio-group>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    Education History
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-card elevation="0">
                                        <v-card-text>
                                            <v-row v-for="(count, i) in item.education.length" :key="i">
                                                <v-col cols="12">Entry #{{count}}</v-col>
                                                <v-col cols="12"><v-text-field label="Degree" outlined v-model="item.education[count-1].degree" readonly></v-text-field></v-col>
                                                <v-col cols="12"><v-text-field label="University Attended" outlined v-model="item.education[count-1].university" readonly></v-text-field></v-col>
                                                <v-col cols="12"><v-text-field label="Status" outlined v-model="item.education[count-1].status" readonly></v-text-field></v-col>
                                                <v-col cols="12"><v-text-field label="Area of Specialization" outlined v-model="item.education[count-1].specialization" readonly></v-text-field></v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    Employment History
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-card elevation="0">
                                        <v-card-text>
                                            <v-row>
                                                <v-col cols="6">
                                                    <v-text-field outlined v-model="item.employment.taught" readonly label="Taught at King's"></v-text-field>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-text-field readonly label="Employee Number (if known)" outlined v-model="item.employment.employeenumber"></v-text-field>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-textarea readonly height="70px" label="Course(s) taught at Kings (if applicable)" outlined v-model="item.employment.courses"></v-textarea>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    References
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-card elevation="0">
                                        <v-card-text>
                                            <v-row v-for="(count, i) in 3" :key="i">
                                                <v-col cols="12">Reference {{count}}</v-col>
                                                <v-col cols="12"><v-text-field label="Name" outlined v-model="item.references[count-1].name" readonly></v-text-field></v-col>
                                                <v-col cols="12"><v-text-field label="Academic Affiliation" outlined v-model="item.references[count-1].academicaffiliation" readonly></v-text-field></v-col>
                                                <v-col cols="12"><v-text-field label="Email Address" outlined v-model="item.references[count-1].email" readonly></v-text-field></v-col>
                                                <v-col cols="12"><v-text-field label="Phone" outlined v-model="item.references[count-1].phone" readonly></v-text-field></v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    Documents
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-card elevation="0">
                                        <v-card-text>
                                            <v-simple-table style="width: 100%; border-collapse: collapse;">
                                                <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                            <th>Type</th>
                                                            <th>File Name</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>Resume/CV</td>
                                                            <td>{{ item.fileCV }}</td>
                                                        </tr>
                                                        <tr v-if="item.hasOwnProperty('suppletype1')">
                                                            <td>{{ item.suppletype1 }}</td>
                                                            <td>{{ item.filesupple1 }}</td>
                                                        </tr>
                                                        <tr v-if="item.hasOwnProperty('suppletype2')">
                                                            <td>{{ item.suppletype2 }}</td>
                                                            <td>{{ item.filesupple2 }}</td>
                                                        </tr>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-card-text>
                </v-card>
            </v-card-text>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
export default {
    props: {
        item: {
            required: true
        }
    },
    data(){
        return {
            host: location.hostname.toString(),
            panel: [0, 1, 2, 3, 4],
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
        }
    },
    methods: {
        resolveTerm(stream, session){
            const that = this;
            let term = stream.slice(-1);
            var year = stream[1]+stream[2];
            var year2 = (parseInt(year)+1).toString();
            var century = (parseInt(stream[0])-1).toString();
            if(term == "9"){
                if(session == "0" || session == "5" || session == "Q5"){
                    return "FALL2"+century+year+"/WINTER2"+century+year2;
                }else if(session == "1" || session == "6"){
                    return "FALL 2"+century+year
                }else{
                    return "WINTER 2"+century+year2
                }
            }else if(term == "5"){
                return "SUMMER 2"+century+year;
            }
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    }
}
</script>